import { createFileRoute } from '@tanstack/react-router';
import { TranslationsPage } from '@/modules/translations/translations-page';

/**
 * Путь совпадает с `webreports.WEBObjects` (ObjectID 204, приложение
 * portal-v2) — именно он ставит пункт в меню. Он намеренно отличается от
 * легаси-адреса `/translations`: на общем origin оба портала живут рядом, и
 * одинаковый путь означал бы ссылку сразу в два места.
 *
 * Данные страница берёт не у бекенда портала, а у сервиса переводов через
 * `/translations-api/` этого же origin.
 */
export const Route = createFileRoute('/_auth/translations-v2')({
  component: TranslationsPage,
});
